import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-7795">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-7796">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-7797">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-7798">
            <ArrowLeft className="w-4 h-4" data-id="element-7799" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-7800">NOIZA</div>
          <div className="w-20" data-id="element-7801" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-7802">
        <div className="mb-12" data-id="element-7803">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-7804">
            <FileText className="w-6 h-6 text-white/80" data-id="element-7805" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-7806">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-7807">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-7808">
          <section data-id="element-7809">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7810">
              <span className="text-[#006847]" data-id="element-7811">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7812">
              <p data-id="element-7813">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-7814">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7815">
                <li data-id="element-7816">Haber leído íntegramente este documento</li>
                <li data-id="element-7817">Comprender su contenido en su totalidad</li>
                <li data-id="element-7818">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-7819">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-7820">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7821">
              <span className="text-[#006847]" data-id="element-7822">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-7823">
              <p data-id="element-7824">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7825">
                <li data-id="element-7826">Software como servicio (SaaS)</li>
                <li data-id="element-7827">Marketplace digital gastronómico</li>
                <li data-id="element-7828">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-7829">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7830">
                <li data-id="element-7831">Mostrar su menú digital</li>
                <li data-id="element-7832">Recibir pedidos de clientes</li>
                <li data-id="element-7833">Gestionar su operación interna</li>
                <li data-id="element-7834">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-7835">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-7836">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7837">
              <span className="text-[#006847]" data-id="element-7838">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7839">
              <p data-id="element-7840">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7841">
                <li data-id="element-7842">No es proveedor de alimentos</li>
                <li data-id="element-7843">No participa en la preparación de productos</li>
                <li data-id="element-7844">No manipula alimentos en ningún momento</li>
                <li data-id="element-7845">No realiza entregas ni logística</li>
                <li data-id="element-7846">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-7847">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-7848">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-7849">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7850">
              <span className="text-[#006847]" data-id="element-7851">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-7852">
              <p data-id="element-7853">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-7854">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7855">
                <li data-id="element-7856">El restaurante es el único responsable de su operación</li>
                <li data-id="element-7857">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-7858">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-7859">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7860">
                <li data-id="element-7861">Precios</li>
                <li data-id="element-7862">Menú</li>
                <li data-id="element-7863">Horarios</li>
                <li data-id="element-7864">Métodos de pago</li>
                <li data-id="element-7865">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7866">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7867">
              <span className="text-[#006847]" data-id="element-7868">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-7869">
              <div data-id="element-7870">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7871">
                  5.1. Alcance general
                </h3>
                <p data-id="element-7872">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-7873">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7874">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-7875">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-7876">
                  <li data-id="element-7877">Calidad de los alimentos</li>
                  <li data-id="element-7878">Estado, frescura o preparación</li>
                  <li data-id="element-7879">Ingredientes utilizados</li>
                  <li data-id="element-7880">Contaminación cruzada</li>
                  <li data-id="element-7881">Problemas de higiene o salubridad</li>
                  <li data-id="element-7882">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-7883">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-7884">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7885">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-7886">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7887">
                  <li data-id="element-7888">Retrasos en la entrega</li>
                  <li data-id="element-7889">Pérdida de pedidos</li>
                  <li data-id="element-7890">Entregas incompletas</li>
                  <li data-id="element-7891">Errores en dirección</li>
                  <li data-id="element-7892">Conducta de repartidores</li>
                  <li data-id="element-7893">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-7894">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7895">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-7896">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-7897">
                  <li data-id="element-7898">Recepción de pagos</li>
                  <li data-id="element-7899">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-7900">Manejo de efectivo</li>
                  <li data-id="element-7901">Confirmación de pagos</li>
                  <li data-id="element-7902">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-7903">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7904">
                  <li data-id="element-7905">Pagos no recibidos</li>
                  <li data-id="element-7906">Comprobantes falsos</li>
                  <li data-id="element-7907">Errores en montos</li>
                  <li data-id="element-7908">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-7909">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7910">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-7911">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-7912">
                  <li data-id="element-7913">Reclamos de clientes</li>
                  <li data-id="element-7914">Reembolsos</li>
                  <li data-id="element-7915">Cancelaciones</li>
                  <li data-id="element-7916">Disputas</li>
                  <li data-id="element-7917">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-7918">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-7919">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7920">
              <span className="text-[#006847]" data-id="element-7921">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-7922">
              <p data-id="element-7923">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7924">
                <li data-id="element-7925">Responsable</li>
                <li data-id="element-7926">Legal</li>
                <li data-id="element-7927">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-7928">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7929">
                <li data-id="element-7930">Publicar información falsa</li>
                <li data-id="element-7931">Manipular precios de forma engañosa</li>
                <li data-id="element-7932">Simular disponibilidad inexistente</li>
                <li data-id="element-7933">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7934">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7935">
              <span className="text-[#006847]" data-id="element-7936">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-7937">
              <p data-id="element-7938">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7939">
                <li data-id="element-7940">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-7941">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-7942">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7943">
                <li data-id="element-7944">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-7945">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-7946">
                    <li data-id="element-7947">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-7948">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-7949">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7950">
              <span className="text-[#006847]" data-id="element-7951">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-7952">
              <p data-id="element-7953">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7954">
                <li data-id="element-7955">Menú digital</li>
                <li data-id="element-7956">Gestión de pedidos</li>
                <li data-id="element-7957">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-7958">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-7959">
                  <p className="font-medium text-white mb-2" data-id="element-7960">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7961">
                    <li data-id="element-7962">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-7963">
                  <p className="font-medium text-white mb-2" data-id="element-7964">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7965">
                    <li data-id="element-7966">Propiedad del software</li>
                    <li data-id="element-7967">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-7968">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-7969">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7970">
              <span className="text-[#006847]" data-id="element-7971">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-7972">
              <p data-id="element-7973">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7974">
                <li data-id="element-7975">Disponibilidad continua</li>
                <li data-id="element-7976">Funcionamiento sin interrupciones</li>
                <li data-id="element-7977">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-7978">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7979">
                <li data-id="element-7980">Fallas técnicas</li>
                <li data-id="element-7981">Actualizaciones</li>
                <li data-id="element-7982">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-7983">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-7984">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7985">
              <span className="text-[#006847]" data-id="element-7986">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-7987">
              <p data-id="element-7988">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7989">
                <li data-id="element-7990">No está garantizada permanentemente</li>
                <li data-id="element-7991">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-7992">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7993">
                <li data-id="element-7994">Destacar o no restaurantes</li>
                <li data-id="element-7995">Modificar posiciones</li>
                <li data-id="element-7996">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7997">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7998">
              <span className="text-[#006847]" data-id="element-7999">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8000">
              <p data-id="element-8001">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8002">
                <li data-id="element-8003">Cumplir con los pagos acordados</li>
                <li data-id="element-8004">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8005">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8006">
                <li data-id="element-8007">Suspender el servicio</li>
                <li data-id="element-8008">Limitar funcionalidades</li>
                <li data-id="element-8009">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8010">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8011">
              <span className="text-[#006847]" data-id="element-8012">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8013">
              <p data-id="element-8014">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8015">
                <li data-id="element-8016">Incumplimiento de términos</li>
                <li data-id="element-8017">Uso indebido</li>
                <li data-id="element-8018">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8019">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8020">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8021">
              <span className="text-[#006847]" data-id="element-8022">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8023">
              <p data-id="element-8024">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8025">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8026">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8027">
              <span className="text-[#006847]" data-id="element-8028">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8029">
              <p data-id="element-8030">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8031">
                <li data-id="element-8032">Pérdidas económicas</li>
                <li data-id="element-8033">Daños indirectos</li>
                <li data-id="element-8034">Lucro cesante</li>
                <li data-id="element-8035">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8036">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8037">
              <span className="text-[#006847]" data-id="element-8038">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8039">
              <p data-id="element-8040">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8041">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8042">
              <span className="text-[#006847]" data-id="element-8043">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8044">
              <p className="font-medium" data-id="element-8045">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8046">
                <li data-id="element-8047">Ha leído este documento completo</li>
                <li data-id="element-8048">Comprende su alcance</li>
                <li data-id="element-8049">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}